import React from 'react';
import { IShapeProps } from './types';
import { Circle } from 'react-konva';
import Konva from 'konva';

const CircleCanvasElement: React.FC<IShapeProps> = (props) => {

  const shapeRef = (props.shapeRef as React.MutableRefObject<Konva.Circle>);

  return (
    <Circle
      {...props.renderProps}
      ref={shapeRef}
    />
  );
};

export default CircleCanvasElement;